import { Component } from '@angular/core';
import { WithDatasourceComponent } from './with-datasource.component';
import { ErpCountryValue } from 'app/rm/erp/common/person/model/person-values';

@Component( {
    selector: 'erp-pbw-land',
    templateUrl: './with-datasource.component.html'
} )
export class CountryFormComponent extends WithDatasourceComponent<ErpCountryValue>   {

    constructor() {
        super(
            {
                datasourceName: 'api/v1/rm/erp/person/value/erpcountry',
                fieldDisplayName: 'text',
                i18nIdentifier: 'rm.erp.jobapplication.JobApplication.country',
            } );
    }

    set value( t: ErpCountryValue | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.country = t;
        }
    }

    get value(): ErpCountryValue | undefined {
        return this.jobapplication?.country;
    }

    getFieldValue( t?: ErpCountryValue ): string | undefined {
        return t?.text;
    }
}
